export default {
    addressValidationModal: {
        class: {
            modal: 'address-validator',
            header: 'address-validator__header',
            modalMessage: 'address-validator__message',
        },
        id: {
            back: 'address-validator__back',
            continue: 'address-validator__continue',
            suggestedAddressPicker: 'address-validator__suggestedAddress',
            originalAddressPicker: 'address-validator__originalAddress',
        },
    },
    availableRewards: {
        id: {
            rewardErrorBanner: 'available-rewards__errorBanner',
            rewardNote: 'available-rewards__note',
        },
        class: {
            option: 'available-rewards__option',
        },
    },
    datetimepicker: {
        class: {
            hour: 'datetimepicker__hour',
            minute: 'datetimepicker__minute',
            period: 'datetimepicker__period',
        },
    },
    notificationScheduler: {
        id: {
            neverRadio: 'never_radio',
            oneTimeRadio: 'oneTime_radio',
            oneTimeInput: 'oneTime_input',
            recurringRadio: 'recurring_radio',
            recurringSelect: 'recurring_select',
            stopAfterDaysCheckBox: 'stopAfterDays_checkbox',
            stopAfterSaysInput: 'stopAfterDays_input',
            emailRemindersHeader: 'emailReminders_header',
        },
    },
};
